var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-image-2 inner"},[_c('div',{staticClass:"text-image-2-image"},[_c('div',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(_vm.item.image),expression:"item.image"}],staticClass:"text-image-2-image-image"})]),_c('div',{staticClass:"text-image-2-text ecc",domProps:{"innerHTML":_vm._s(_vm.item.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }